import React, { FC, JSX, useEffect, useState } from "react";
import "./ModalAccessProfilePartnerPermission.scss";
import ModalDefault from "../../../../components/ModalDefault/ModalDefault";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, Col, FormGroup, Row } from "react-bootstrap";
import { schema } from "./Validate";
import { useAccessProfile } from "../../../../providers/Access/AccessProfile/AccessProfileProvider";
import { AccessPageModel } from "../../../../models/Access/AccessPage/AccessPageModel";
import SkeletonTable from "../../../SkeletonTable/SkeletonTable";
import { BvIcon } from "bevi-icon";
import InputSearchPartner from "../../../InputSearchPartner/InputSearchPartner";

interface ModalAccessProfilePartnerPermissionProps {
  show: boolean;
  onClose: () => void;
}

const ModalAccessProfilePartnerPermission: FC<
  ModalAccessProfilePartnerPermissionProps
> = ({ show, onClose }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isLoadingSearch, setIsLoadingSearch] = useState<boolean>(false);
  const [expandedRow, setExpandedRow] = useState<number>();
  const [pagesAccess, setPagesAccess] = useState<any[]>([]);
  const [hasSearched, setHasSearched] = useState<boolean>(false);
  const [valuePartner, setValuePartner] = useState<any>();
  const [partnerObj, setPartnerObj] = useState<any | null>(null);
  const {
    handleListPages,
    accessPages,
    isLoadingModalAccess,
    partnerMenu,
    setError,
    handlePartnerPermission,
    handlePartnerMenuList,
  } = useAccessProfile();

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const reset = () => {
    setValue("partner", null);
    setValuePartner("");
    setPartnerObj(null);
    setPagesAccess([]);
    setExpandedRow(0);
    setHasSearched(false);
  };

  useEffect(() => {
    if (show) {
      reset();
      handleListPages({ withPaginate: false });
    }
  }, [show]);

  useEffect(() => {
    const search = async () => {
      if (!partnerObj || !valuePartner) {
        setHasSearched(false);
        return;
      }

      setIsLoadingSearch(true);
      await handlePartnerMenuList(valuePartner);
      setIsLoadingSearch(false);
      setHasSearched(true);
    };

    search();
  }, [partnerObj]);

  useEffect(() => {
    if (partnerMenu) {
      const pagesAccessPartnerCode: any[] = [];

      partnerMenu.forEach((element: AccessPageModel) => {
        if (element?.children && element?.children?.length > 0) {
          element?.children?.forEach((x: AccessPageModel) => {
            if (pagesAccessPartnerCode.includes(x?.id)) {
              const index = pagesAccessPartnerCode.indexOf(x?.id);
              pagesAccessPartnerCode.slice(index, 1);
            } else {
              pagesAccessPartnerCode.push(x?.id);
            }
          });
        }
        if (pagesAccessPartnerCode.includes(element?.id)) {
          const index = pagesAccessPartnerCode.indexOf(element?.id);
          pagesAccessPartnerCode.splice(index, 1);
        } else {
          pagesAccessPartnerCode.push(element?.id);
        }
      });

      setPagesAccess(pagesAccessPartnerCode);
    }
  }, [partnerMenu]);

  const handleClose = () => {
    setError("");
    reset();
    onClose();
  };

  const onSubmit = async (data: any) => {
    if (!valuePartner) return;

    setIsLoadingSubmit(true);
    setError("");

    const permission = {
      partner_code: valuePartner,
      access_pages: pagesAccess,
    };

    const ret = await handlePartnerPermission(permission);

    if (ret) {
      toast.success("Acessos atribuídos com sucesso!");
      handleClose();
    }

    setIsLoadingSubmit(false);
  };

  const handleCheckedPages = (id?: number) => {
    if (!id) return;

    setPagesAccess((prev) => {
      if (prev.includes(id)) {
        return prev.filter((pageId) => pageId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const renderPagesChildren = (item: AccessPageModel): JSX.Element => {
    return (
      <tr>
        <td colSpan={4}>
          <div className="p-3 bg-light rounded">
            <Card>
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th className="text-uppercase opacity-7 text-center w-10"></th>
                    <th className="text-uppercase opacity-7 w-45">Nome</th>
                    <th className="text-uppercase opacity-7 w-45">URL</th>
                  </tr>
                </thead>
                <tbody>
                  {item?.children && item?.children?.length > 0 ? (
                    <>
                      {item?.children?.map((x: AccessPageModel) => (
                        <tr key={x.id}>
                          <td className="text-center">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={x?.name}
                                name={x?.name}
                                checked={pagesAccess.includes(x?.id)}
                                onChange={() => handleCheckedPages(x?.id)}
                              />
                            </div>
                          </td>
                          <td className="text-sm">{x?.name}</td>
                          <td className="text-sm">{x?.layout}</td>
                        </tr>
                      ))}
                    </>
                  ) : null}
                </tbody>
              </table>
            </Card>
          </div>
        </td>
      </tr>
    );
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {accessPages.length > 0 ? (
          <>
            {accessPages.map((item: AccessPageModel) => {
              if (item?.children && item?.children?.length > 0) {
                return (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={item?.name}
                            name={item?.name}
                            checked={pagesAccess.includes(item?.id)}
                            onChange={() => handleCheckedPages(item?.id)}
                          />
                        </div>
                      </td>
                      <td className="text-sm">{item.name}</td>
                      <td className="text-sm">{`/${item.path_name}`}</td>
                      <td className="text-end">
                        <a
                          onClick={() =>
                            setExpandedRow(
                              expandedRow === item.id ? 0 : item.id
                            )
                          }
                        >
                          <BvIcon
                            name={
                              expandedRow === item.id
                                ? "chevronUp"
                                : "chevronDown"
                            }
                            weight={600}
                            width={25}
                            height={25}
                          />
                        </a>
                      </td>
                    </tr>
                    {expandedRow === item.id && renderPagesChildren(item)}
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={item?.name}
                            name={item?.name}
                            checked={pagesAccess.includes(item?.id)}
                            onChange={() => handleCheckedPages(item?.id)}
                          />
                        </div>
                      </td>
                      <td className="text-sm">{item.name}</td>
                      <td className="text-sm">{`/${item.path_name}`}</td>
                      <td className="text-end"></td>
                    </tr>
                  </React.Fragment>
                );
              }
            })}
          </>
        ) : (
          <tr>
            <td colSpan={4} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoadingModalAccess && !isLoadingSearch ? (
          <Row>
            <Col md={12} className="mb-3">
              Páginas
            </Col>
            <Col md={12}>
              <Card>
                <div className="table-responsive">
                  <table className="table table-flush m-0 w-100">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-uppercase opacity-7 text-center w-10"></th>
                        <th className="text-uppercase opacity-7 w-45">Nome</th>
                        <th className="text-uppercase opacity-7 w-45">URL</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>{renderList()}</tbody>
                  </table>
                </div>
              </Card>
            </Col>
          </Row>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  return (
    <ModalDefault
      title={"Atribuir acesso por parceiro"}
      show={show}
      icon="article"
      onClose={handleClose}
      sizeModal={"lg"}
      showFooter={true}
      buttonText={isLoadingSubmit ? "Salvando..." : "Salvar"}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit || !partnerObj || !hasSearched}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className={`ModalAccessProfilePartnerPermission ${
          partnerObj ? "has-partner" : ""
        }`}
        data-testid="ModalAccessProfilePartnerPermission"
      >
        <Row>
          <Col md={partnerObj ? 6 : 4}>
            <FormGroup className="form-group">
              <label htmlFor="partner">CÓDIGO DO PARCEIRO *</label>
              <InputSearchPartner
                name="partner"
                control={control}
                setValue={setValue}
                valuePartner={valuePartner}
                setValuePartner={setValuePartner}
                setPartnerObj={setPartnerObj}
                errors={errors}
                errorLabel="Parceiro"
              />
            </FormGroup>
          </Col>
        </Row>

        {(isLoadingSearch || hasSearched) && renderContent()}
      </div>
    </ModalDefault>
  );
};

export default ModalAccessProfilePartnerPermission;
